export default __webpack_public_path__ + "static/media/Type 18.b06be917.jpg";